// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"7680653c","453":"d855a71b","455":"6a9e6f4b","457":"c7d82238","551":"52a7b25b","851":"05fff0bf"}[chunkId] + ".chunk.js";
};